import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { CustomMessagesService } from '@core/errors/custom-messages.service';
import { Group, GroupDialogData, PermissionCategorie } from '@core/interfaces';
import { getErrorCode } from '@core/utils/get-error-code';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { TranslateService } from '@ngx-translate/core';
import { chain } from 'lodash';
import { sentry } from 'sentry';
import { GroupService } from '../services/groups-api.service';
var DialogGroupsComponent = /** @class */ (function () {
    function DialogGroupsComponent(data, matDialogRef, authenticationService, customMessageService, progressBar, translateService, groupsService, fb) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.authenticationService = authenticationService;
        this.customMessageService = customMessageService;
        this.progressBar = progressBar;
        this.translateService = translateService;
        this.groupsService = groupsService;
        this.fb = fb;
        this.tabSegmentsClicked = false;
        this.selectedTabIndex = 0;
        this.isSaving = false;
        this.hasLocationsPermissionsEnabled = true;
        this.hasEditGroupPermission = false;
        this.group = this.data.group;
        this.isViewMode = this.data.isViewMode;
        this.disabled = this.group.id && this.group.locked;
        this.hasEditGroupPermission = this.authenticationService.hasPermission('groups-edit');
    }
    DialogGroupsComponent.prototype.ngOnInit = function () {
        this.initForm();
        this.hasLocationsPermissionsEnabled = this.authenticationService.hasAccountPreference({
            defaultIfUndefined: true,
            expectedValue: true,
            property: 'other',
            subProperty: 'featureLocationsPermissionsEnabled'
        });
    };
    DialogGroupsComponent.prototype.initForm = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.groupForm = this.fb.group({
                            id: [this.group.id],
                            name: [{ value: this.group.name, disabled: this.disabled || this.isViewMode }, [Validators.required]],
                            description: [{ value: this.group.description, disabled: this.disabled || this.isViewMode }, [Validators.maxLength(200)]],
                            categories: new FormArray([]),
                        });
                        _a = this;
                        return [4 /*yield*/, this.groupsService.listAllPermissionsCategories()];
                    case 1:
                        _a.permissionsCategories = _b.sent();
                        this.initCategoriesForm();
                        if (this.isViewMode) {
                            this.groupForm.disable();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogGroupsComponent.prototype.initCategoriesForm = function () {
        var e_1, _a, e_2, _b;
        var _this = this;
        var categoriesFormArray = this.fb.array([]);
        try {
            for (var _c = tslib_1.__values(this.permissionsCategories), _d = _c.next(); !_d.done; _d = _c.next()) {
                var category = _d.value;
                categoriesFormArray.push(this.fb.group({
                    name: category.category,
                    title: category.translation[this.translateService.currentLang].title,
                    description: category.translation[this.translateService.currentLang].description,
                    checked: false,
                    expanded: false,
                    indeterminate: false,
                    permissions: this.fb.array(category.permissions.map(function (permission) {
                        return _this.fb.group({
                            id: permission.id,
                            name: permission.name,
                            featureFlag: permission.featureFlag,
                            title: permission.translation[_this.translateService.currentLang].title,
                            description: permission.translation[_this.translateService.currentLang].description,
                            checked: _this.group.permissions.some(function (groupPermission) { return groupPermission.id === permission.id; }),
                        });
                    })),
                }));
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        var isDisabled = this.disabled || this.isViewMode;
        try {
            for (var _e = tslib_1.__values(categoriesFormArray.controls), _f = _e.next(); !_f.done; _f = _e.next()) {
                var control = _f.value;
                if (isDisabled) {
                    control.disable();
                }
                else {
                    control.enable();
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.groupForm.setControl('categories', categoriesFormArray);
    };
    DialogGroupsComponent.prototype.toGroupInput = function (formValue) {
        var selectedPermissionIds = chain(formValue.categories)
            .map(function (category) { return category.permissions; })
            .flatten()
            .filter(function (permission) { return permission.checked; })
            .map(function (permission) { return permission.id; })
            .value();
        return {
            name: formValue.name,
            description: formValue.description,
            permissions: selectedPermissionIds
        };
    };
    DialogGroupsComponent.prototype.saveGroup = function (_a) {
        var closeDialog = _a.closeDialog;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupInput, success, _b, err_1, code;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.isSaving = true;
                        this.progressBar.show();
                        groupInput = this.toGroupInput(this.groupForm.value);
                        success = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, 5, 6]);
                        _b = this;
                        return [4 /*yield*/, this.groupsService.save(this.group.id, groupInput)];
                    case 2:
                        _b.group = _c.sent();
                        return [4 /*yield*/, this.refreshPermissions()];
                    case 3:
                        _c.sent();
                        if (closeDialog) {
                            this.matDialogRef.close(true);
                            this.customMessageService.success('GROUPS.SUCCESS_MESSAGE');
                        }
                        success = true;
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _c.sent();
                        code = getErrorCode(err_1);
                        if (code === 'group_name_duplicated') {
                            this.groupForm.get('name').setErrors({
                                group_name_duplicated: true
                            });
                        }
                        this.customMessageService.error('GROUPS.ERROR_MESSAGE');
                        return [3 /*break*/, 6];
                    case 5:
                        this.isSaving = false;
                        this.progressBar.hide();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/, success];
                }
            });
        });
    };
    DialogGroupsComponent.prototype.archiveOrUnarchiveUserGroup = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        this.isSaving = true;
                        this.progressBar.show();
                        return [4 /*yield*/, this.groupsService.archiveOrUnarchiveUserGroup(this.group)];
                    case 1:
                        _a.sent();
                        this.customMessageService.success('GROUPS.SUCCESS_MESSAGE');
                        this.matDialogRef.close({ reloadDataTable: true });
                        return [3 /*break*/, 4];
                    case 2:
                        err_2 = _a.sent();
                        sentry.captureException(err_2);
                        this.customMessageService.error('GROUPS.ERROR_MESSAGE');
                        this.matDialogRef.close();
                        return [3 /*break*/, 4];
                    case 3:
                        this.isSaving = false;
                        this.progressBar.hide();
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    DialogGroupsComponent.prototype.continue = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var savedSuccessfully;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectedTabIndex !== 0) {
                            this.selectedTabIndex++;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.saveGroup({ closeDialog: false })];
                    case 1:
                        savedSuccessfully = _a.sent();
                        if (savedSuccessfully) {
                            this.selectedTabIndex = 1;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DialogGroupsComponent.prototype.refreshPermissions = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authenticationService.refreshTokenAndPermissions()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DialogGroupsComponent;
}());
export { DialogGroupsComponent };
